import type { CohortGrid } from '../../models/cohort.types'

export function scaleCohortGrid(grid: CohortGrid): CohortGrid {
  const scaleValues = grid.rows.flatMap((row) =>
    row.cells.flatMap((cell) => (cell.percent !== 0 && cell.percent !== 100 ? [cell.percent] : [])),
  )
  const min = scaleValues.length > 0 ? Math.min(...scaleValues) : 0
  const max = scaleValues.length > 0 ? Math.max(...scaleValues) : min
  return {
    ...grid,
    rows: grid.rows.map((row) => ({
      ...row,
      cells: row.cells.map((cell) => ({
        ...cell,
        intensity: max === min ? 0 : Math.min(1, Math.max(0, (cell.percent - min) / (max - min))),
      })),
    })),
  }
}
